import { types, type Instance } from 'mobx-state-tree';

import ModalStore from './ModalStore';

const UiStore = types
  .model('UiStore', {
    modalStore: types.optional(ModalStore, {}),
    documentExpanded: types.optional(types.boolean, false),
    isJobTabsSticky: types.optional(types.boolean, false),
  })
  .actions((self) => {
    const setDocumentExpanded = (expanded: boolean) => {
      self.documentExpanded = expanded;
    };
    const setIsJobTabsSticky = (isSticky: boolean) => {
      if (self.isJobTabsSticky !== isSticky) {
        self.isJobTabsSticky = isSticky;
      }
    };
    return {
      setDocumentExpanded,
      setIsJobTabsSticky,
    };
  });

export interface IUiStore extends Instance<typeof UiStore> {}

export default UiStore;
